import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { CartCouponComponent } from '@spartacus/cart/base/components';
import { CartVoucherFacade } from '@spartacus/cart/base/root';
import { CustomerCouponService, UserIdService } from '@spartacus/core';
import { CartAuxService } from '../../../_core/cart-aux.service';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../components/toaster/toaster.model';
import { CustomActiveCartService } from '../../../_core/active-cart.service';
import { combineLatest, filter, Subscription, switchMap, take } from 'rxjs';
import { isEmpty } from '../../../../../../core/services/simple-tools';

@Component({
  selector: 'cx-cart-coupon',
  templateUrl: './cart-coupon.component.html',
  styleUrl: 'cart-coupon.component.scss',
  standalone: false,
})
export class CustomCartCouponComponent extends CartCouponComponent implements OnInit {
  voucherSubscription = new Subscription();

  constructor(
    cartVoucherService: CartVoucherFacade,
    formBuilder: UntypedFormBuilder,
    customerCouponService: CustomerCouponService,
    activeCartService: CustomActiveCartService,
    private cartAuxService: CartAuxService,
    private toasterService: ToasterService,
    private userIDService: UserIdService,
  ) {
    super(cartVoucherService, formBuilder, customerCouponService, activeCartService);
  }

  override applyVoucher(): void {
    this.couponForm.markAllAsTouched();

    if (this.couponForm.valid) {
      this.subscription.add(
        combineLatest([this.userIDService.getUserId(), this.activeCartService.getActive()])
          .pipe(
            filter(([userId, cart]) => !isEmpty(userId) && !isEmpty(cart?.code)),
            take(1),
            switchMap(([userId, cart]) => {
              return this.cartAuxService.setVoucher({
                voucherCode: this.couponForm.get('couponCode')?.value,
                cartID: cart.code!,
                userID: userId,
              });
            }),
          )
          .subscribe(response => {
            if (response.hasError) {
              this.toasterService.closeALL();

              this.toasterService.init({
                type: TOASTER_TYPE.DANGER,
                content: response.message!,
              });
            } else {
              this.activeCartService.reloadActiveCart();
            }
          }),
      );
    }
  }
}
